import { SWRConfiguration, SWRResponse } from 'swr';
import { GetNamespaces, Namespace } from '../../api/dtos';
import { useGet } from '@ngt/opms';


const request = () =>  new GetNamespaces();

const getData = (response?: SWRResponse<Namespace[], Namespace[]>) => response?.data;
const getError = (response?: SWRResponse<Namespace[], Namespace[]>) => ((response?.error ?? response?.data) as any)?.responseStatus;

export const useNamespaces = (configuration?: SWRConfiguration) => {
    return useGet(request, { getData, getError}, configuration);
};

export default useNamespaces;
